export function buildLoginRedirectPath(targetPath: string): string {
  const params = new URLSearchParams({ redirect: targetPath });
  return `/login?${params.toString()}`;
}

const TEAM_INVITE_COOKIE_NAME = 'miles_team_invite_token';

export function getSafeLoginRedirectPath(search: string): string {
  const redirectPath = new URLSearchParams(search).get('redirect');

  if (
    !redirectPath ||
    !redirectPath.startsWith('/') ||
    redirectPath.startsWith('//') ||
    redirectPath.includes('\\')
  ) {
    return '/';
  }

  return redirectPath;
}

export function getTeamInviteTokenFromRedirectPath(path: string): string | null {
  const match = /^\/team\/invite\/([^/?#]+)$/.exec(path);
  if (!match) return null;

  try {
    return decodeURIComponent(match[1]);
  } catch {
    return null;
  }
}

export function getTeamInviteTokenFromLoginSearch(
  search: string,
): string | null {
  return getTeamInviteTokenFromRedirectPath(getSafeLoginRedirectPath(search));
}

export function persistTeamInviteTokenForAuth(search: string): string | null {
  const token = getTeamInviteTokenFromLoginSearch(search);

  try {
    const domainAttr = window.location.hostname.endsWith('.bymiles.ai')
      ? '; domain=.bymiles.ai'
      : '';
    const cookieValue = token ? encodeURIComponent(token) : '';
    const maxAge = token ? 15 * 60 : 0;
    document.cookie = `${TEAM_INVITE_COOKIE_NAME}=${cookieValue}; path=/; samesite=lax; max-age=${maxAge}${domainAttr}`;
  } catch {
    // Auth can still proceed for existing users; new invite signups will fail closed.
  }

  return token;
}

export function buildAuthCallbackUrl(origin: string, search: string): string {
  return `${origin}${getSafeLoginRedirectPath(search)}`;
}

export function buildAuthErrorCallbackUrl(
  origin: string,
  search: string,
  authEntryPath: '/login' | '/signup' = '/login',
): string {
  const redirectPath = getSafeLoginRedirectPath(search);

  if (redirectPath === '/') {
    return `${origin}${authEntryPath}`;
  }

  const params = new URLSearchParams({ redirect: redirectPath });
  return `${origin}${authEntryPath}?${params.toString()}`;
}
